import { useContext, useEffect, useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { BsPlusCircleFill } from "react-icons/bs"
import { FaPen } from "react-icons/fa"
import { Link } from "react-router-dom"
import Get from "../../api/Get"
import { GET_USUARIOS_ALL } from "../../api/Routes"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"
import TableSearch from "../../components/TableSearch"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"

function ListUsuario({t, url}){
    const [loading, setLoading] = useState(true)
    const {auth} = useContext(authContext)
    const [items, setItems] = useState([])
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        setLoading(true)
        Get({url: GET_USUARIOS_ALL, access_token: auth.data.access_token})
        .then(response=>{
            setItems(response.data.data.response)
            setLoading(false)
        })
        .catch(error=>{
            setLoading(false)
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }, [])

    const actions = (cell, row, index) => {        
        return (
            <div>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><Link to={`${url}/crear?id=${row.id}`}><FaPen className='iconAction colorNaranja' /></Link></li>                   
                    {/* <li className="list-inline-item cursor-pointer"><MdDeleteSweep className='iconAction colorRojo' 
                        onClick={e=>{
                            setIdDelete(row.id)
                            setShowDelete(true)
                        }} /></li> */}
                </ul>          
            </div>
        );
    }
    const formatActive = cell => {        
        return cell ? <span className="text-success">Si</span> : <span className="text-danger">No</span>
    }

    // const onHandleDelete = () =>{
    //     setIsDeleting(true)
    //     Delete({url: `${DELETE_USUARIO}/${idDelete}`, access_token: auth.data.access_token})
    //     .then(response=>{
    //         let arr = items.filter(el=>el.id!==idDelete)
    //         setItems(arr)
    //         setIsDeleting(false)
    //         setShowDelete(false)
    //     })
    //     .catch(error=>{
    //         console.log(error)
    //     })
    // }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, 
        {
            dataField: 'name',
            text: 'NOMBRE',
            headerStyle: { width: '35%' },
        },
        {
            dataField: 'phoneNumber',
            text: 'Teléfono',
            headerStyle: { width: '15%' },
        },
        {
            dataField: 'email',
            text: 'Correo electrónico / Usuario',
            headerStyle: { width: '25%' },
        },
        {
            dataField: 'userType',
            text: 'Tipo de usuario',
            headerStyle: { width: '30%' },
        },
        {
            dataField: 'active',
            text: 'Activo',
            headerStyle: { width: '5%', textAlign: 'center' },
            style: {textAlign:'center'},
            formatter: formatActive, 
        },
        {
            dataField: '',
            isDummyField: true,
            text: 'ACCIONES',
            style:{
                textAlign: 'center'
            },
            headerStyle: { width: '10%', textAlign: 'center' },
            formatter: actions,            
        }
    ]

    return (
        <>
            {loading && <LoadingList />}
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Usuarios</h2>
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">                        
                        <Col className="text-right">
                            <Link to={`${url}/crear`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>                
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>                            
                            <TableSearch columns={columns} items={items}/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* <ModalDelete 
                showDelete={showDelete} 
                onHandleDelete={(onHandleDelete)} 
                setShowDelete={setShowDelete}
                isDeleting={isDeleting}
            /> */}
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
}

export default ListUsuario